import { useRef } from 'react';

/**
 * Use this hook to conditionally track some (probably stateful) value.
 *
 * @param value        Whatever value you are tracking
 * @param condition    While condition is true, the hook's return value tracks the input
 *                     While condition is false, the hook's return value does not change
 */

export function useConditionalStateSync<T>(value: T, condition: boolean): T {
  const valueRef = useRef(value);
  if (condition) {
    valueRef.current = value;
  }
  return valueRef.current;
}
